import styled from 'styled-components'

export const SelectWrapper = styled.div`
  width: 100%;
  min-height: 48px;
  margin-top: ${({ label }) => label && '-5px;'};
`

export const SelectInput = styled.select`
  display: none;
`

export const SelectOption = styled.option`
  color: ${({ theme }) => theme.colors.primary};
`

export const SelectInputLabel = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled }) => (disabled ? 'none' : 'inline-block')};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme }) => theme.colors.primary};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme }) => `1px solid ${theme.colors.borderColor}`};

  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.background)};
  border-radius: ${({ open }) => (open ? '10px 10px 0 0' : '10px')};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
`

export const SelectInputOptionsContainer = styled.div`
  z-index: 3;
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.primary};

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 400;
  background-color: ${({ theme }) => theme.colors.background};
  border-left: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  border-right: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  border-radius: ${({ open }) => (open ? '0 0 10px 10px' : '10px')};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  user-select: none;
`

export const SelectInputOptions = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;

  transition: 0.4s;

  border-radius: 8px;
  border: ${({ disabled }) => !disabled && '1px solid rgba(0, 0, 0, 0)'};
  color: ${(props) => props.theme.colors.primary};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background: ${({ theme, disabled }) => !disabled && theme.colors.backgroundLite};
  }
`

export const SelectPlaceholder = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Abbreviation = styled.div`
  color: ${({ theme }) => theme.colors.backgroundLite};
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const Text = styled.div`
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
